/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionnaireEvaluateResult
 */
export interface QuestionnaireEvaluateResult {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireEvaluateResult
     */
    profileId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateResult
     */
    recommendedSolution: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateResult
     */
    explanation: string;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireEvaluateResult
     */
    recommendedStrategyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateResult
     */
    correlationId?: string | null;
}

/**
 * Check if a given object implements the QuestionnaireEvaluateResult interface.
 */
export function instanceOfQuestionnaireEvaluateResult(value: object): value is QuestionnaireEvaluateResult {
    if (!('recommendedSolution' in value) || value['recommendedSolution'] === undefined) return false;
    if (!('explanation' in value) || value['explanation'] === undefined) return false;
    return true;
}

export function QuestionnaireEvaluateResultFromJSON(json: any): QuestionnaireEvaluateResult {
    return QuestionnaireEvaluateResultFromJSONTyped(json, false);
}

export function QuestionnaireEvaluateResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireEvaluateResult {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'recommendedSolution': json['recommendedSolution'],
        'explanation': json['explanation'],
        'recommendedStrategyId': json['recommendedStrategyId'] == null ? undefined : json['recommendedStrategyId'],
        'correlationId': json['correlationId'] == null ? undefined : json['correlationId'],
    };
}

export function QuestionnaireEvaluateResultToJSON(json: any): QuestionnaireEvaluateResult {
    return QuestionnaireEvaluateResultToJSONTyped(json, false);
}

export function QuestionnaireEvaluateResultToJSONTyped(value?: QuestionnaireEvaluateResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'profileId': value['profileId'],
        'recommendedSolution': value['recommendedSolution'],
        'explanation': value['explanation'],
        'recommendedStrategyId': value['recommendedStrategyId'],
        'correlationId': value['correlationId'],
    };
}

